import { EndpointMutation } from '../../request';

export interface IntelligentReminderParams {
  eventType: 'bookingStarted' | 'bookingCreated';
  utmMedium: 'email' | 'sms';
  utmSource: 'intelligent-reminder';
  utmContent: 'book-again-started' | 'book-again-finished';
  userAgent?: string;
  userId?: string; // if userId is available
  timeZone: string;
  metadata: {
    appointmentId: string;
  };
}

export class TrackIntelligentReminderMutation extends EndpointMutation<void, IntelligentReminderParams> {
  // standalone variable, as the `this.baseURL` value can't be read
  protected url: string;

  constructor(apiUrl: string) {
    super();
    this.url = `${apiUrl}/v1/analytics/event`;
  }

  async request(payload: IntelligentReminderParams, signal?: AbortSignal): Promise<void> {
    try {
      await fetch(this.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
        signal,
      });
    } catch (error) {
      // ignore network error
    }
  }
}
